/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { withRouter, useLocation } from "react-router-dom";
import userDetail from "Stores/userDetail";
import queryString from "query-string";
import InputBox from "Components/Register/InputBox";
import Button from "Components/common/Button";
import { Utils } from "Utils/utils";
import {
  CLIENT_URL,
  GOOGLE_CLIENT_ID,
  MP_EVENT,
  WEBSITE_URL
} from "Static/constant";
import makeApi, { URLS } from "Utils/apiURL";
import PhoneNumberInput from "Components/common/PhoneNumberInput";
import { captchaStoreValue } from "Stores/captcha";
import EmailVerification from "./EmailVerification";
import GoogleImg from "Assets/logo/google.webp";
import AlertBox, { alertStore } from "Components/common/AlertBox";
import { getVisitorId } from "Utils/FingerprintUtils";

const SignupComponent = props => {
  let location = useLocation();
  let queryParams = Utils.getQueryParams(location.search);
  let pluginUser = queryParams?.get("source")?.includes("plugin");
  pluginUser && localStorage.setItem("isPluginUser", true);

  const [firstName, setFirstName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState({
    password: "",
    showPassword: false
  });
  const [isAgreeTC, setIsAgreeTC] = useState(false);
  const [isStorePersonal, setIsStorePersonal] = useState(false);
  const [isProductAnnouncement, setIsProductAnnouncement] = useState(false);
  const [firstNameErr, setFirstNameErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [phoneErr, setPhoneErr] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [agreeTCErr, setAgreeTCErr] = useState("");
  const [storePersonalErr, setStorePersonalErr] = useState("");
  const [loader, setLoader] = useState(false);
  const timeZoneValidation = Utils.validateEUTimeZone();
  const userEuChecked = Utils.isEuCheckboxEnabled(isAgreeTC, isStorePersonal);
  const [phone, setPhoneNumber] = useState("");
  const [emailVerification, setEmailVerification] = useState(false);
  const [verificationData, setVerificationData] = useState({});
  const [isValidEmail, setIsValidEmail] = useState(false);
  const authPopupRef = useRef(null);

  const checkEuRegister = (firstNameValid, emailValid, passwordValid) => {
    let isValidInput = firstNameValid && emailValid && passwordValid;
    if (timeZoneValidation) {
      let isEuCheckboxEnabled = Utils.isEuCheckboxEnabled(
        isAgreeTC,
        isStorePersonal
      );
      return pluginUser
        ? isValidInput && isEuCheckboxEnabled
        : isValidInput && isEuCheckboxEnabled;
    } else {
      return pluginUser ? isValidInput : isValidInput;
    }
  };

  const signup = async token => {
    const visitorId = await getVisitorId();
    try {
      const config = {
        url: URLS.signupUserV2,
        method: "POST",
        data: {
          email: userEmail?.trim()?.toLowerCase() || "",
          password: userPassword?.password || "",
          first_name: firstName,
          emailPreferences: isProductAnnouncement,
          source:
            localStorage.getItem("isPluginUser") || pluginUser
              ? "PLUGIN"
              : "WEB",
          type: pluginUser ? "PLUGIN" : "WEB",
          token,
          visitorId,
          mixpanelInfo: {
            pageType:
              localStorage.getItem("isPluginUser") || pluginUser
                ? "PLUGIN"
                : "WEB"
          },
          utmSource: "" /* Utils.readCookie("uts") */,
          utmMedium: "" /* Utils.readCookie("utm") */,
          utmCampaign: "" /* Utils.readCookie("utc") */,
          utmContent: "" /* Utils.readCookie("uta")*/,
          userTimezone: {
            zone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
            zone_value: Utils.getCurrentUserTimeZone()
          },
          redirectUrl: `/signupSuccess?redirect=${pluginUser ? "plugin" : "dashboard"
            }`
        }
      };

      let response = await makeApi(config);
      switch (response?.data?.toString()) {
        case "true":
          pluginUser && localStorage.removeItem("pluginUser");
          localStorage.setItem("isOnboarding", true);
          setVerificationData({
            ...verificationData,
            email: userEmail,
            token
          });
          setEmailVerification(true);
          if (window && window.sg) {
            var sg = window.sg;
            sg.identify(userEmail);
          }
          break;
        case "limit":
          mpFailedEventType("limit");
          setErrMsg(`We have noticed too many registrations from this domain. Please
                <a target="_blank" rel="noopener noreferrer" href="mailto:support@salesgear.io">contact support</a> for further help`);
          setLoader(false);
          break;
        case "business":
          mpFailedEventType("business");
          setIsValidEmail(false);
          setEmailErr("Please enter a valid work email address");
          setLoader(false);
          break;
        case "invalid":
          setIsValidEmail(false);
          setEmailErr("Please enter a valid email address");
          setLoader(false);
          break;
        case "false":
          setLoader(false);
          setIsValidEmail(false);
          setEmailErr("Email address already exists");
          break;
        case "disposable":
          mpFailedEventType("disposable");
          setIsValidEmail(false);
          setEmailErr("Please enter a valid email address");
          setLoader(false);
          break;
        case "blocked":
          mpFailedEventType("blocked");
          setErrMsg("Something went wrong. Please try again later");
          setLoader(false);
          break;
        default:
          mpFailedEventType("failed");
          setLoader(false);
          setErrMsg("Something went wrong");
          break;
      }
    } catch (err) {
      setLoader(false);
      console.error("Signup Error", err);
    }
  };

  const submitForm = e => {
    e.preventDefault();
    if (e.keyCode === 13) {
      Utils.removeInputRequired(e);
      executeCaptcha();
    }
  };

  const firstNameChange = value => {
    setFirstName(value);
    setFirstNameErr("");
    setErrMsg("");
  };

  const emailChange = value => {
    setUserEmail(value?.trim().toLowerCase() || "");
    setEmailErr("");
    setErrMsg("");
  };

  const passwordChange = value => {
    setUserPassword(value);
    setPasswordErr("");
    setErrMsg("");
  };

  const changePhoneNumber = number => {
    setPhoneNumber(number);
    setPhoneErr("");
    setErrMsg("");
  };

  const agreeTCClick = () => {
    setIsAgreeTC(!isAgreeTC);
    setAgreeTCErr("");
    setErrMsg("");
  };

  const storePersonalClick = () => {
    setIsStorePersonal(!isStorePersonal);
    setStorePersonalErr("");
    setErrMsg("");
  };

  const productAnnouncementClick = () => {
    setIsProductAnnouncement(!isProductAnnouncement);
  };

  const termsAndContAndPrivacy = () => {
    return (
      <span>
        By signing up, you are accepting our
        <a
          href={`${WEBSITE_URL}/terms-of-service`}
          target="_blank"
          rel="noopener noreferrer"
        >
          &nbsp;Terms&nbsp;
        </a>{" "}
        and
        <a
          href={`${WEBSITE_URL}/privacy-policy`}
          target="_blank"
          rel="noopener noreferrer"
        >
          &nbsp;Privacy Policy.
        </a>
      </span>
    );
  };

  const executeCaptcha = e => {
    e && Utils.removeInputRequired(e);
    let isEmailValid = Utils.emailValidate(
      userEmail?.trim()?.toLowerCase() || ""
    );
    let isPasswordValid = Utils.validateStringLength(
      userPassword?.password || "",
      6
    );
    let isFirstNameValid = Utils.validateStringLength(firstName.trim(), 1);
    if (
      !emailErr &&
      checkEuRegister(isFirstNameValid, isEmailValid, isPasswordValid)
    ) {
      setLoader(true);
      Utils.mixpanelTrack(MP_EVENT.SIGNUP_CLICKED, {
        pageType: "Signup",
        name: `${firstName}`,
        userEmail,
        source: ""
      });
      captchaStoreValue.executeCaptcha(validateCaptchaFromAPi);
    } else if (!isEmailValid && !emailErr) {
      setEmailErr("Please enter a valid email address");
      setLoader(false);
    } else if (!isPasswordValid) {
      setPasswordErr(
        userPassword?.password
          ? "Password must be at least 6 characters"
          : "Password is required"
      );
      setLoader(false);
    } else if (!isFirstNameValid) {
      setFirstNameErr("Please enter the name");
      setLoader(false);
    } else if (!userEuChecked) {
      !isAgreeTC && setAgreeTCErr("Please accept our terms and privacy policy");
      !isStorePersonal &&
        setStorePersonalErr("Please give your consent to store information");
      setLoader(false);
      return false;
    } else {
      setLoader(false);
      setErrMsg("Please check your email address or password");
    }
  };

  const validateCaptchaFromAPi = async token => {
    token && signup(token);
  };

  const mpFailedEventType = (type = "failed") => {
    Utils.mixpanelTrack(MP_EVENT.SIGN_UP_FAILED, {
      pageType: "Signup Page",
      email: userEmail,
      type
    });
  };

  const validateBusinessEmail = async (token = "") => {
    if (token) {
      try {
        const config = {
          url: URLS.validateBusinessEmailV2,
          method: "POST",
          data: {
            email: (userEmail || "").trim(),
            token
          }
        };

        const { data = {}, status = "" } = await makeApi(config);
        const success = data?.success;
        const validBusinessEmail = data?.validBusinessEmail;
        const message = data?.message;

        if (+status === 200) {
          alertStore.setShowStatusPopup(false);
          if (data) {
            if (!validBusinessEmail) {
              setEmailErr(message);
            } else if (!success && validBusinessEmail) {
              setEmailErr(message);
            } else if (success && validBusinessEmail) {
              setIsValidEmail(true);
            }
          } else {
            setEmailErr("Please enter a valid work email address");
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoader(false);
      }
    }
  };

  const validateBusinessEmailWithCaptcha = () => {
    setLoader(true);
    if (userEmail) {
      let isValidEmail = Utils.emailValidate(
        userEmail?.trim()?.toLowerCase() || ""
      );
      if (isValidEmail) {
        captchaStoreValue.executeCaptcha(validateBusinessEmail);
      } else {
        setEmailErr("Please enter a valid email address");
        setLoader(false);
      }
      setErrMsg("");
    } else {
      setLoader(false);
    }
  };

  const validateBusinessEmailBlurAction = () => {
    if (userEmail) {
      let isValidEmail = Utils.emailValidate(
        userEmail?.trim()?.toLowerCase() || ""
      );
      if (!isValidEmail) {
        setEmailErr("Please enter a valid email address");
      }
      setErrMsg("");
    }
  };

  const emailValidatedInputBoxObjList = [
    {
      name: "firstName",
      id: "firstName",
      type: "text",
      value: firstName,
      changeAction: firstNameChange,
      keyupAction: submitForm,
      errMsg: firstNameErr,
      label: "",
      isPassword: false,
      placeholder: "eg: John",
      isLabelOnBorder: true,
      labelBorderTxt: "Name"
    },

    {
      name: "password",
      id: "password",
      type: "password",
      value: userPassword,
      changeAction: value =>
        passwordChange({ ...userPassword, password: value }),
      keyupAction: submitForm,
      errMsg: passwordErr,
      label: "",
      className: "password",
      isPassword: true,
      placeholder: "Password",
      showPasswordAction: () =>
        setUserPassword({
          ...userPassword,
          showPassword: !userPassword?.showPassword
        }),
      isLabelOnBorder: true,
      labelBorderTxt: "Password"
    }
  ];

  const inputBoxObjList = [
    {
      name: "workEmail",
      id: "workEmail",
      type: "email",
      value: userEmail,
      changeAction: emailChange,
      keyupAction: submitForm,
      blurAction: validateBusinessEmailBlurAction,
      errMsg: emailErr,
      label: "",
      isPassword: false,
      focus: true,
      isLabelOnBorder: true,
      labelBorderTxt: "Enter Work Email"
    }
  ];

  const euCheckBoxObjList = [
    {
      id: "termCondition",
      name: "termCondition",
      type: "checkbox",
      className: "checkbox",
      checked: isAgreeTC,
      change: agreeTCClick
    },
    {
      id: "storePersonal",
      name: "storePersonal",
      type: "checkbox",
      className: "checkbox",
      checked: isStorePersonal,
      change: storePersonalClick,
      text: "I give my consent to store my personal information outside the European Union."
    },
    {
      id: "productAnnouncement",
      name: "productAnnouncement",
      type: "checkbox",
      className: "checkbox",
      checked: isProductAnnouncement,
      change: productAnnouncementClick,
      text: "I would like to receive email updates from Salesgear on new product announcements and upgrades."
    }
  ];
  const getInitialize = () => {
    const queryObject = queryString?.parse(location.search);
    const storedSignupEmail =
      queryObject["email"] || localStorage.getItem("signupEmail") || "";
    storedSignupEmail &&
      !["null", "undefined"].includes(storedSignupEmail) &&
      setUserEmail(storedSignupEmail || "");
    localStorage.setItem("signupEmail", storedSignupEmail);
    Utils.mixpanelTrack(MP_EVENT.SIGNUP_VISITED, {
      pageType: "Signup"
    });
  };

  useEffect(() => {
    getInitialize();
  }, []);

  useEffect(() => {
    const handleLoginSuccess = () => {
      if (authPopupRef.current && !authPopupRef.current.closed) {
        authPopupRef.current.close();
      }
      window.top.location.href = "/dashboard";
    };

    const onMessage = (event) => {
      const { data = "" } = event;
      if (data?.type === "WEB_GOAUTH_ACCESS") {
        handleLoginSuccess();
      }
    };

    window.addEventListener("message", onMessage);

    let bc;
    if (typeof BroadcastChannel !== "undefined") {
      bc = new BroadcastChannel("google_auth");
      bc.onmessage = (event) => {
        if (event.data?.type === "WEB_GOAUTH_ACCESS") {
          handleLoginSuccess();
        } else if (event.data?.type === "GOOGLE_OUTH_ERR") {
          if (authPopupRef.current && !authPopupRef.current.closed) {
            authPopupRef.current.close();
          }
          window.postMessage(event.data, "*");
        }
      };
    }

    return () => {
      window.removeEventListener("message", onMessage);
      if (bc) bc.close();
    };
  }, []);

  useEffect(() => {
    const handleAlertBox = e => {
      const { data = "" } = e;
      const {
        type = "",
        message = "",
        msgType = "",
        popupState = false
      } = data;
      if (type === "GOOGLE_OUTH_ERR") {
        alertStore.setShowStatusPopup(popupState);
        alertStore.setAlertMessage(message, msgType);
      }
    };
    window.addEventListener("message", handleAlertBox);
    return () => {
      window.removeEventListener("message", handleAlertBox);
    };
  }, []);

  useEffect(() => {
    const handlePluginSourceRedirection = e => {
      const { data = "" } = e;
      const { type = "", redirectionUrl = "" } = data;
      if (type === "PLUGIN_SOURCE_SIGNUP") {
        window.location.href = redirectionUrl;
      }
    };
    window.addEventListener("message", handlePluginSourceRedirection);
    return () => {
      window.removeEventListener("message", handlePluginSourceRedirection);
    };
  }, []);

  return !emailVerification ? (
    <>
      <section
        className={`formInputBox ${loader ? "pointerUserSelectNone" : ""}`}
      >
        {isValidEmail ? (
          <>
            {" "}
            <form id="signupform" autoComplete="on">
              {emailValidatedInputBoxObjList.map(item => (
                <InputBox {...item} key={item.id} />
              ))}
            </form>
            {errMsg && (
              <span
                className="errMsgText"
                style={{ position: "relative", bottom: "10px" }}
              >
                {errMsg}
              </span>
            )}
            <div className="signupBtnWrapper">
              <Button
                id="signupBtn"
                name="signupBtn"
                btnText="Back"
                className={
                  "signupBtn btn-new btn-rounded btn-orange btn-text btn-arrow back"
                }
                type="button"
                onClick={() => setIsValidEmail(false)}
              />
              <Button
                id="signupBtn"
                name="signupBtn"
                btnText="Start for free"
                className={
                  loader
                    ? "loading"
                    : "signupBtn btn-new btn-rounded btn-orange btn-text btn-arrow startFree"
                }
                loader={loader}
                type="button"
                click={e => {
                  e.preventDefault();
                  executeCaptcha(e);
                }}
              />
            </div>
          </>
        ) : (
          <>
            {" "}
            <h3>Get Started for Free</h3>
            <div className="googleLoginBtn">
              <button
                type="button"
                className="signInWithGoogleBtn"
                onClick={async () => {
                  const w = 600;
                  const h = 800;
                  const left = window.screen.width / 2 - w / 2;
                  const top = window.screen.height / 2 - h / 2;
                  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=${left},top=${top}`;
                  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=email%20profile&access_type=offline&include_granted_scopes=true&response_type=code&redirect_uri=${encodeURIComponent(
                    `${CLIENT_URL}/connect/gAuth/callback`
                  )}&client_id=${GOOGLE_CLIENT_ID}&state=${pluginUser ? "PLUGIN" : "WEB"
                    }`;
                  // Store the reference so we can close it later
                  getVisitorId().then(visitorId => {
                    console.log("Fingerprint Visitor ID (on Google Signup):", visitorId);
                  });
                  authPopupRef.current = window.open(authUrl, "Salesgear", params);
                }}
              >
                <img src={GoogleImg} alt="Google" />
                Sign In with Google
              </button>
            </div>
            <AlertBox />
            <div className="signupSeparator">OR</div>
            <form id="signupform" autoComplete="on">
              {inputBoxObjList.map(item => (
                <InputBox {...item} key={item.id} />
              ))}
            </form>
            {errMsg && (
              <span
                className="errMsgText"
                style={{ position: "relative", bottom: "10px" }}
              >
                {errMsg}
              </span>
            )}
            {!timeZoneValidation && (
              <div className="termsAndPolicyText">
                {termsAndContAndPrivacy()}
              </div>
            )}
            {timeZoneValidation && (
              <div className="eu-checbox-section">
                <span className="err-eu-check">{agreeTCErr}&nbsp;</span>
                <span className="err-eu-check">{storePersonalErr}&nbsp;</span>
                <ul className="checkbox-tick">
                  {euCheckBoxObjList.map(item => {
                    const {
                      id = "",
                      name = "",
                      type = "checkbox",
                      checked = false,
                      change = () => { },
                      text = "",
                      className = ""
                    } = item || {};
                    return (
                      <li className="list-item" key={id}>
                        <label htmlFor={id}>
                          <input
                            id={id}
                            name={name}
                            type={type}
                            className={className}
                            checked={checked}
                            onChange={change}
                          />
                          <span>
                            {id === "termCondition"
                              ? termsAndContAndPrivacy()
                              : text}
                          </span>
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <Button
              id="signupBtn"
              name="signupBtn"
              btnText="Continue"
              className={
                loader
                  ? "loading"
                  : "signupBtn btn-new btn-rounded btn-orange btn-text btn-arrow"
              }
              loader={loader}
              type="button"
              onClick={validateBusinessEmailWithCaptcha}
            />
          </>
        )}
      </section>
    </>
  ) : (
    <EmailVerification verificationData={verificationData} />
  );
};

export default withRouter(SignupComponent);
